import { pageInfo, downtemplate, uploadSoldtoAuthorization, deleteData, soldtoAuthorizationEdit, submit, deleteBatch, exportData } from './../api'
const customer = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    downtemplateObj: null,
    uploadAuthorizationObj: null,
    deleteDataObj: null,
    exportDataObj: null,
    soldtoAuthorizationEditData: null,
    submitData: null,
    deleteBatchObj: null
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, true] }));
    },
    DOWN_TEMPLATE_DATA(state,data){
      state.downtemplateObj = data;
    },
    UPLOAD_SOLDTO_AUTHORIZATION_DATA(state,data){
      state.uploadAuthorizationObj = data;
    },
    DELETE_DATA(state,data){
      state.deleteDataObj = data;
    },
    EXPORT_DATA(state,data){
      state.exportDataObj = data;
    },
    EDIT_DATA(state,data){
      state.soldtoAuthorizationEditData = data.obj || {};
    },
    SUBMIT_DATA(state,data){
      state.submitData = data;
    },
    DELETE_BATCH_DATA(state,data){
      state.deleteBatchObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async downtemplate({commit}, obj){
      let resp = await downtemplate(obj);
      commit('DOWN_TEMPLATE_DATA', resp);
    },
    async uploadSoldtoAuthorization({commit}, obj){
      let resp = await uploadSoldtoAuthorization(obj);
      commit('UPLOAD_SOLDTO_AUTHORIZATION_DATA', resp);
    },
    async deleteData({commit}, obj){
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    async exportData({commit}, obj){
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async soldtoAuthorizationEdit({commit}, obj){
      let resp = await soldtoAuthorizationEdit(obj);
      commit('EDIT_DATA', resp);
    },
    async submit({commit}, obj){
      let resp = await submit(obj);
      commit('SUBMIT_DATA', resp);
    },
    async deleteBatch({commit}, obj){
      let resp = await deleteBatch(obj);
      commit('DELETE_BATCH_DATA', resp);
    }
  }
}
export default customer



// WEBPACK FOOTER //
// ./src/page/md/soldToAuthorization/store/soldToAuthorization.store.js